import { useQuery } from '@tanstack/react-query'
import { meQuery } from '../api/jedi'
import { DEFAULT_ZONE, dayOf } from '../shell/workRank'

/*
  THE PERSON'S DAY, for everything that is not the rank (RAID #482; ruled by
  Erik 2026-09-21 and 22). Dates count in the zone the person set in Settings,
  and in Eastern until they set one; times are shown in it. `dayOf` lives in
  `workRank.ts`, which the parity check runs in Node and so cannot import, and
  is re-exported here for everyone else.
*/
export { DEFAULT_ZONE, dayOf }

/** The zone the signed-in person's day is counted in: theirs, or Eastern until `/me` answers. */
export function usePersonZone(): string {
  const me = useQuery(meQuery)
  return me.data?.timeZone ?? DEFAULT_ZONE
}

/** Today where the person is, as YYYY-MM-DD. */
export function todayIn(zone: string, now = new Date()): string {
  return dayOf(now, zone)
}

/** A YYYY-MM-DD date moved by whole days. Calendar arithmetic on the date itself, so no zone or DST can shift it. */
export function addDays(day: string, days: number): string {
  const d = new Date(`${day}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

/** The weekday of a YYYY-MM-DD date: 0 is Sunday. */
export function weekdayOf(day: string): number {
  return new Date(`${day}T00:00:00Z`).getUTCDay()
}

/** A moment as the person reads it: the browser's own format, in the person's zone rather than the machine's. */
export function whenIn(at: string | Date, zone: string): string {
  return new Date(at).toLocaleString(undefined, { timeZone: zone })
}
